module.exports = __webpack_public_path__ + "img/ic_cvv.e47a006a.svg";